import { NAMESPACE } from 'react/api/actions/base';

export const actions = {
  fetchInitialFormValues: `${NAMESPACE}_FETCH_INITIAL_FORM_VALUES`,
  fetchInitialFormValuesSuccess: `${NAMESPACE}_FETCH_INITIAL_FORM_VALUES_SUCCESS`,
  saveForm: `${NAMESPACE}_SAVE_FORM`,
  saveFormSuccess: `${NAMESPACE}_SAVE_FORM_SUCCESS`,
  saveFormError: `${NAMESPACE}_SAVE_FORM_ERROR`,
  clearFormError: `${NAMESPACE}_CLEAR_FORM_ERROR`,
  clearFormState: `${NAMESPACE}_CLEAR_FORM_STATE`,
  addFieldCriteria: `${NAMESPACE}_ADD_FIELD_CRITERIA`,
  invalidSubmitCustom: `${NAMESPACE}_INVALID_SUBMIT_CUSTOM`
};

export const actionCreators = {
  fetchInitialFormValues: (payload) => ({
    type: actions.fetchInitialFormValues,
    payload
  }),
  fetchInitialFormValuesSuccess: (payload) => ({
    type: actions.fetchInitialFormValuesSuccess,
    payload
  }),
  saveForm: (payload) => ({ type: actions.saveForm, payload }),
  saveFormSuccess: (payload) => ({ type: actions.saveFormSuccess, payload }),
  saveFormError: (payload) => ({ type: actions.saveFormError, payload }),
  clearFormError: (payload) => ({ type: actions.clearFormError, payload }),
  clearFormState: (payload) => ({ type: actions.clearFormState, payload }),
  addFieldCriteria: (payload) => ({ type: actions.addFieldCriteria, payload }),
  invalidSubmitCustom: (payload) => ({
    type: actions.invalidSubmitCustom,
    payload
  })
};

export default {
  actions,
  actionCreators
};
